import { ComponentType, lazy } from 'react';
import { SidePanelType } from 'features/side-panels/types';

export const loadPanelView = (panelName: SidePanelType): ComponentType =>
  lazy(() => import(`features/${panelName}/panel/Panel`));
